export enum SubstanceTypeEnum {
  None = 'none',
  SingleEntity = 'single-entity',
  Salt = 'salt',
  SingleEntityAndSalt = 'single-entity-drug-and-salt',
  Revision = 'revision',
  ContactLensMaterial = 'contact-lens-material',
  Biologics = 'biologics'
}
